import React from 'react'

import {Colors, Popover, Button} from '../UI/index.js'
import {Check} from '../UI/forms/index.js'
import t from '../../helpers/Languages.js'

export const branchIcon = 'mdi mdi-office-building-marker-outline'

/**
 * Chooses the branches the planner shows, in a Popover with a check per branch. The anchor is the label in the top bar,
 * or children(label) (a row of the side nav, with placement 'right').
 */
class BranchSelector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {stagedBranchIds: props.selectedBranchIds}
    }

    onOpen() {
        this.setState({stagedBranchIds: this.props.selectedBranchIds})
    }

    onOutsideClick() {
        this.setState({stagedBranchIds: this.props.selectedBranchIds})
    }

    onSelectAll() {
        this.setState({stagedBranchIds: []})
    }

    onToggleBranch(id) {
        const {stagedBranchIds} = this.state

        const next = stagedBranchIds.includes(id) ?
            stagedBranchIds.filter((branchId) => branchId !== id) :
            [...stagedBranchIds, id]

        this.setState({stagedBranchIds: next})
    }

    onConfirm() {
        this.props.onChange(this.state.stagedBranchIds)
        this.popover?.close()
    }

    render() {
        const {branches, selectedBranchIds, placement, popoverStyle, onToggle, children} = this.props
        const {stagedBranchIds} = this.state

        const style = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 16,
            color: Colors.textDark,
            cursor: 'pointer',
            width: 'auto',
            height: '100%',
            marginLeft: 20
        }

        const label = selectedBranchIds.length === 0 ?
            t('allBranches') :
            selectedBranchIds.length === 1 ?
                branches.find((branch) => branch.id === selectedBranchIds[0])?.name :
                `${selectedBranchIds.length} ${t('branches').toLowerCase()}`

        return (
            <Popover
                ref={(ref) => this.popover = ref}
                noClose
                placement={placement}
                popoverStyle={popoverStyle || {marginLeft: 6}}
                onToggle={(show) => {
                    show && this.onOpen()
                    onToggle?.(show)
                }}
                onOutsideClick={this.onOutsideClick.bind(this)}
                content={
                    <div style={{padding: '8px 12px', width: 260}}>
                        <Check checked={stagedBranchIds.length === 0} label={t('allBranches')} onChange={this.onSelectAll.bind(this)} />

                        {branches.map((branch) => (
                            <Check
                                key={branch.id}
                                checked={stagedBranchIds.includes(branch.id)}
                                label={branch.name}
                                onChange={() => this.onToggleBranch(branch.id)}
                            />
                        ))}

                        <Button
                            style={{marginTop: 12, width: '100%'}}
                            label={t('confirm')}
                            onClick={this.onConfirm.bind(this)}
                        />
                    </div>
                }
            >
                {children ?
                    children(label) :
                    <div style={style}>
                        <div style={{height: '100%', display: 'flex', alignItems: 'center'}}>
                            <i style={{marginRight: 12, fontSize: 20}} className={branchIcon} />
                            {label}
                            <i className='mdi mdi-menu-down' />
                        </div>

                        <div style={{height: 4, width: '100%'}} />
                    </div>
                }
            </Popover>
        )
    }
}

export default BranchSelector
